export default "__VITE_ASSET__DHFch4u4__"